import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import { FORM_CONTROL_SX } from "../constants";
import { FieldError } from "./FieldError";

export type RegisterAccountFieldsProps = {
  loading: boolean;
  companyName: string;
  onCompanyNameChange: (value: string) => void;
  email: string;
  onEmailChange: (value: string) => void;
  emailInvalid: boolean;
  fullname: string;
  onFullnameChange: (value: string) => void;
  phoneNumber: string;
  onPhoneNumberChange: (value: string) => void;
  address: string;
  onAddressChange: (value: string) => void;
};

export function RegisterAccountFields({
  loading,
  companyName,
  onCompanyNameChange,
  email,
  onEmailChange,
  emailInvalid,
  fullname,
  onFullnameChange,
  phoneNumber,
  onPhoneNumberChange,
  address,
  onAddressChange,
}: RegisterAccountFieldsProps) {
  return (
    <FormControl sx={FORM_CONTROL_SX}>
      <label>
        COMPANY NAME<span className="star-requied">*</span>
      </label>
      <TextField
        disabled={loading}
        className="input-register"
        sx={{ width: "100%" }}
        value={companyName}
        onChange={(e) => onCompanyNameChange(e.target.value)}
        required
        color="success"
        placeholder="Enter company name"
      />
      <label>
        SALES REP. EMAIL <span className="star-requied">*</span>
      </label>
      <TextField
        className="input-register"
        sx={{ width: "100%" }}
        disabled={loading}
        required
        placeholder="Enter email address"
        onChange={(e) => onEmailChange(e.target.value)}
        error={emailInvalid}
        type="email"
        value={email}
        color={emailInvalid ? "error" : "success"}
      />
      {emailInvalid && <FieldError>Email invalidate.</FieldError>}
      <label>
        SALES REP. NAME<span className="star-requied">*</span>
      </label>
      <TextField
        disabled={loading}
        className="input-register"
        sx={{ width: "100%" }}
        value={fullname}
        onChange={(e) => onFullnameChange(e.target.value)}
        required
        color="success"
        placeholder="Enter fullname"
      />
      <label>
        SALES REP. PHONE<span className="star-requied">*</span>
      </label>
      <TextField
        disabled={loading}
        className="input-register"
        sx={{ width: "100%" }}
        required
        color="success"
        inputMode="numeric"
        value={phoneNumber}
        onChange={(e) => onPhoneNumberChange(e.target.value)}
        placeholder="Enter phone number"
      />
      <label>
        DELIVERY ADDRESS<span className="star-requied">*</span>
      </label>
      <TextField
        className="input-register"
        sx={{ width: "100%" }}
        required
        color="success"
        disabled={loading}
        value={address}
        onChange={(e) => onAddressChange(e.target.value)}
        placeholder="Enter address"
      />
    </FormControl>
  );
}
